//#region Util Imports

import * as _ from 'underscore'
import * as $ from 'jquery'

//#endregion


import { IMRIFrameWrapperOptions, IMRIFrameWrapperMessage } from '../../../common/iframe-wrapper'
import { TypeHelper, ToastHelper, LocalizationHelper, LogHelper } from '../../../../helpers'
import { Enums } from '../../../../models/common'
import { OpDashboard } from '../../../../models/custom'
import { DXDashboardService } from '../../services'


// Public Types

export type IMRDXDashboardSimpleOptions = {
    dashboard: OpDashboard
}

// Public Types End


export class IMRDXDashboardSimpleController implements ng.IComponentController {

    // Consts

    private static get LOG_PREFIX(): string { return '[SIMAX.Module.Dashboard.DXDashboardSimple]' }

    // Consts End


    // Members

    private isLoading: boolean
    private options: IMRDXDashboardSimpleOptions
    private iframeWrapperOptions: IMRIFrameWrapperOptions<any>

    private sessionToken: string

    // Members End


    // Ctor

    constructor(private dxdashboardService: DXDashboardService) { }

    // Ctor End


    // IComponentController Implementation 

    public $onChanges(changes: { [index: string]: ng.IChangesObject<any> }): void {
        if (TypeHelper.isOptionsDefined(changes)) {
            this.initialize();
        }
    }

    // IComponentController Implementation End


    // Component

    private initialize(): void {
        this.isLoading = true

        this.initializedDashboard(this.options.dashboard)
            .then(() => {
                this.isLoading = false
            })
    }

    private initializedDashboard(dashboard: OpDashboard): JQueryPromise<void> {
        const dashboardIndex: number = this.dxdashboardService.getDashboardIndex(dashboard)

        let dashboardUrl: string = null
        let sessionToken: string = null

        if (dashboard.dataList != null) {
            dashboardUrl = dashboard.dataList.getValue(Enums.DataType.DASHBOARD_DX_PATH, dashboardIndex)
            sessionToken = dashboard.dataList.getValue(Enums.DataType.DASHBOARD_DX_TOKEN, dashboardIndex)
        }

        if (!TypeHelper.isNullOrEmpty(dashboardUrl) && !TypeHelper.isNullOrEmpty(sessionToken)) {
            this.iframeWrapperOptions = {
                url: dashboardUrl + '&sessionToken=' + sessionToken,

                onMessage: (message: IMRIFrameWrapperMessage<any>) => this.onIFrameMessage(message),
                onError: () => this.onIframeError(),
            }

            return TypeHelper.onInitializedAll(this.iframeWrapperOptions)
        }

        ToastHelper.showError(LocalizationHelper.getLocalizedText(LocalizationHelper.Text.ExceptionOccuredPleaseContactAnAdministrator))
        LogHelper.warn(IMRDXDashboardSimpleController.LOG_PREFIX, `Missing path or token data for idDashboard: ${dashboard.idDashboard}.`)

        return $.Deferred<void>().resolve().promise()
    }

    private onIFrameMessage(message: IMRIFrameWrapperMessage<any>): void {
        this.dxdashboardService.handleIFrameMessage(message, this.options.dashboard)
    }

    private onIframeError(): void {
        ToastHelper.showError(LocalizationHelper.getLocalizedText(LocalizationHelper.Text.ExceptionOccuredPleaseContactAnAdministrator))
        LogHelper.warn(IMRDXDashboardSimpleController.LOG_PREFIX, `Problem with the iframe.`)
    }

    // Component End
}
